
<template>
    <div class="qksm qksm15">
        <h4>十五、预算绩效评价工作开展情况</h4>
        <div class="nogap">
            <p>
                {{$parent.year}}年度，本{{$parent.typeText}}共<reason type="integer" classname="qksm integer must" name="重点绩效项目" v-model:value="qksm['重点绩效项目']"></reason>
                个项目开展了财政重点绩效评价，涉及财政性资金合计
                <reason type="money" classname="qksm money " name="开展财政性资金" v-model:value="qksm['开展财政性资金']"></reason>万元；
                本{{$parent.typeText}}
                <reason type="select" classname="qksm select " name="是否开展" v-model:value="qksm['是否开展']"></reason>
                {{$parent.typeText}}整体支出财政重点绩效评价，涉及财政性资金
                <reason type="money" classname="qksm money " name="整体财政性资金" v-model:value="qksm['整体财政性资金']" v-if="qksm['是否开展']=='开展'"></reason>
                <template v-else>
                    0
                </template>万元。
            </p>
            <p>
                本{{$parent.typeText}}共对上年度已实施完成的<reason type="integer" classname="qksm integer must" name="实施完成项目" v-model:value="qksm['实施完成项目']"></reason>
                个项目开展了绩效自评价，涉及财政性资金合计 <reason type="money" classname="qksm money " name="实施完成财政资金" v-model:value="qksm['实施完成财政资金']"></reason>万元；
                本{{$parent.typeText}}共开展<reason type="integer" classname="qksm integer must" name="开展绩效自评" v-model:value="qksm['开展绩效自评']"></reason>项{{$parent.typeText}}整体支出绩效自评价，
                涉及财政性资金合计<reason type="money" classname="qksm money " name="涉及财政性资金" v-model:value="qksm['涉及财政性资金']"></reason>万元。
            </p>
        </div>
    </div>
</template>
<script>
    import reason from "@/components/reason.vue";
    export default {
        name: "qksm15",
        components: {
            reason,
        },
        props: {
            //T1: {
            //    type: Object,
            //    default: "",
            //},
        },
        data() {
            var qksm = this.$store.state.divData.qksm
            return {
                isPdf: this.$parent.isPdf,
                qksm: qksm,
            }
        },
        created() {
            this.inspect()
        },
        updated: function () {
            this.inspect()
        },
        mounted() {
        },
        methods: {
            inspect() {
                if (this.qksm['是否开展'] == "开展" && this.num(this.qksm['整体财政性资金']) == 0) {
                    this.addOrSet("qksm15", "请检查本页《十五、预算绩效目标工作开展情况》，如本部门（单位）整体支出选择“开展”重点绩效评价，涉及财政性资金必须要大于“0”万元。");
                } else {
                    this.remove("qksm15")
                }
                if (this.num(this.qksm['重点绩效项目']) > 0 && this.num(this.qksm['开展财政性资金']) <= 0) {
                    this.addOrSet("qksm151", "请检查本页《十五、预算绩效目标工作开展情况》，如开展财政重点绩效评价的项目个数大于0，则后面涉及财政性资金合计数必须要大于“0”万元。");
                } else if (this.num(this.qksm['重点绩效项目']) == 0 && this.num(this.qksm['开展财政性资金']) != 0) {
                    this.addOrSet("qksm151", "请检查本页《十五、预算绩效目标工作开展情况》，如开展财政重点绩效评价的项目个数等于0，则后面涉及财政性资金合计数必须要等于“0”万元。");
                } else {
                    this.remove("qksm151")
                }

                if (this.num(this.qksm['实施完成项目']) > 0 && this.num(this.qksm['实施完成财政资金']) <= 0) {
                    this.addOrSet("qksm152", "请检查本页《十五、预算绩效目标工作开展情况》，如对上年度已实施完成开展了绩效自评的项目个数大于0，则后面涉及财政性资金合计数必须要大于“0”万元。");
                } else if (this.num(this.qksm['实施完成项目']) == 0 && this.num(this.qksm['实施完成财政资金']) != 0) {
                    this.addOrSet("qksm152", "请检查本页《十五、预算绩效目标工作开展情况》，如对上年度已实施完成开展了绩效自评的项目个数等于0，则后面涉及财政性资金合计数必须要等于“0”万元。");
                } else {
                    this.remove("qksm152")
                }


                if (this.num(this.qksm['开展绩效自评']) > 0 && this.num(this.qksm['涉及财政性资金']) <= 0) {
                    this.addOrSet("qksm153", "请检查本页《十五、预算绩效目标工作开展情况》，如开展部门（单位）整体支出绩效自评价的项目个数大于0，则后面涉及财政性资金合计数必须要大于“0”万元。");
                } else if (this.num(this.qksm['开展绩效自评']) == 0 && this.num(this.qksm['涉及财政性资金']) != 0) {
                    this.addOrSet("qksm153", "请检查本页《十五、预算绩效目标工作开展情况》，如开展部门（单位）整体支出绩效自评价的项目个数等于0，则后面涉及财政性资金合计数必须要等于“0”万元。");
                } else {
                    this.remove("qksm153")
                }

            }
        }
    };
</script>
